'use client';

import { useSearchContext } from '../../../../data/context/searchContext';

import Typography from '../../_blocks/Typography/Typography';

import styles from './ExitCallout.module.css';

interface Props {
    pageName: string;
}

/**
 * Exit condition callout component
 * @see https://www.figma.com/design/nc4hug3s5oJ0EzPX2Y4HKO/FEAT%3A-Audience-landing-pages-(new)?node-id=137-45306&node-type=frame&m=dev
 */
const EndOfPageCallout = ({ pageName }: Props) => {
    // Scroll the user back to the top of the page.
    const handleScroll = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <article className={styles.wrapper}>
            <div className={styles.content}>
                <div className="space-y-025">
                    <Typography as="h2" typeset="subtitle" size="300" className="md:type-500">
                        Ready to find your treatment?
                    </Typography>
                    <Typography as="p" typeset="emphasis" size="100">
                        Find helpful information, advice, and the treatment for your condition.
                    </Typography>
                </div>
                <button type="button" onClick={handleScroll} className="type-link">
                    Treatments & Conditions for {pageName}
                </button>
            </div>
        </article>
    );
};

export default EndOfPageCallout;
